import QueryList from "./queryList.gql";
import CallService from "./callService.gql";
import ChangeStatus from "./changeStatus.gql";
import {queryHdl, mutationHdl} from "../graphqlHdr";

export default {
  // 查询服务列表
  queryList: (vueSelf, variables) => queryHdl.call(vueSelf, QueryList, variables),
  // 呼叫服务
  callService: (vueSelf, variables) => mutationHdl.call(vueSelf, CallService, variables),
  // 修改服务状态
  changeStatus: (vueSelf, variables) => mutationHdl.call(vueSelf, ChangeStatus, variables),
}
